// import logo from "assets/logoRELX.png";
import logo from "assets/logoSuitPods.jpeg";

export const images = {
  logo,
};
